// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- Global reset rules */
/* stylelint-disable declaration-property-value-disallowed-list -- Global reset rules */
@import-normalize;

body,
html {
    /* dvh, not vh: on mobile vh is the large viewport, which leaves the
       document scrollable behind the address bar. */
    height: 100dvh;
    color: var(--ds-font-color);
    font-size: var(--ds-font-size-base);
    font-family: var(--ds-font-family), Arial, sans-serif;
    line-height: var(--ds-line-height);
    letter-spacing: 0;
}
/* Styles regarding margin, padding, font-related properties
will be defined in the corresponding components' stylesheets
(buttons, links, typographies */
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-weight: var(--ds-font-weight-regular);
    font-size: var(--ds-font-size-base);
}

a {
    all: unset;
}

input,
select,
textarea,
[popover] {
    color: inherit;
    font-family: inherit;
}

button {
    all: unset;
}

ul,
ol {
    list-style: none;
}

[id='app'] {
    /* dvh, not vh: see the comment on the body/html reset above. */
    height: 100dvh;
}

fieldset {
    all: unset;
}

legend {
    all: unset;
}

dialog {
    background: transparent;
    border: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
